import {Component, ElementRef, Input, OnInit, OnDestroy} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {PropertyByNamePipe} from '../../pipes/property-by-name';
import { ActivatedRoute, Router } from '@angular/router';
import {Item} from '../../models/item.model';
import { ContactService } from '../../services/contact.service';
import smoothscroll from 'smoothscroll-polyfill';
import {Image} from '../../models/image.model';

smoothscroll.polyfill();

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html'
})
export class DetailComponent implements OnInit, OnDestroy {

  @Input() data;

  title = [
    '_DETAIL.TITLE_1'
  ];

  images = [];
  defaultImage: Image;

  titleDescription = [
    '_DETAIL.TITLE_DESCRIPTION_1',
    '_DETAIL.TITLE_DESCRIPTION_2'
  ];


  id: number;
  private sub: any;
  item: Item;
  private itemData: any;

  constructor(private api: ApiService,
              private propertyByNamePipe: PropertyByNamePipe,
              private route: ActivatedRoute,
              private router: Router,
              private contactService: ContactService) {
  }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      this.id = +params.id; // (+) converts string 'id' to a number

      this.loadItem(this.id);
    });
  }

  loadItem(id: number) {
    this.api.getSharedItem(id.toString()).subscribe(
      (item: Item) => {
        item.images.forEach((image, index) => {
          if (item.images.some(i => i.defaultImage)) {
            if (image.defaultImage) {
              this.defaultImage = image;
            }
          } else {
            if (index === 0 && !this.defaultImage) {
              this.defaultImage = image;
            }
          }
          this.images.push(image.id);
        });
        this.item = item;
        this.itemData = JSON.parse(item.json);
        this.images = this.images.sort(
          (i1, i2) => {

            if (i1 > i2 || i2 === this.defaultImage.id) {
              return 1;
            }
            if (i1 < i2 || i1 === this.defaultImage.id) {
              return -1;
            }

            return 0;
          }
        );
      }
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  scroll(element) {
    const el = document.getElementById(element);
    const bodyTop = document.body.getBoundingClientRect().top;
    const elPos = el.getBoundingClientRect().top + 1;
    const scroll = elPos - bodyTop;
    // console.log(scroll);
    window.scrollTo({top: scroll, behavior: 'smooth'});
  }

  requestItem() {
    this.contactService.item = this.item;
    this.router.navigate(['/contact/item', this.item.id]).then();
  }

}
